export const FIELDS = {
  SHOW: {
    TITLE: "Show notice banner",
    SUBTITLE: "Show a notice banner at the top of the page, in both edit and live modes.",
    NAME: "show"
  },
  BANNER_TYPE: {
    TITLE: "Banner type",
    NAME: "color"
  },
  OVERRIDE_BANNER_TEXT: {
    LABEL: "Override banner text",
    NAME: "text"
  },
  DISABLE_CHANGES: {
    TITLE: "Disable all changes",
    SUBTITLE: "Prevent any changes on agent pages and disable the creation of agents and accounts.",
    NAME: "disableChanges"
  },
  DISABLE_PUBLISH: {
    TITLE: "Disable build and publish",
    SUBTITLE: "Disable the ability to build and publish changes.",
    NAME: "disablePublish"
  },
  DISABLE_BD: {
    TITLE: "Disable branch deployer",
    SUBTITLE: "Disable the ability to create and manage branch deployers.",
    NAME: "disableBd"
  },
  CUSTOM_MESSAGE: {
    LABEL: "Custom banner message",
    NAME: "customText"
  },
  ROLES: {
    TITLE: "Limit banner to roles",
    SUBTITLE: "Only users holding one of the selected roles will see the banner. Leave empty to show it to everyone.",
    NAME: "roles",
    PLACEHOLDER: "Select roles",
    ERROR: "Roles could not be loaded. Try again later."
  }
};

export const COLORS = {
  INCIDENT: "#EF404B",
  MAINTENANCE: "#F1B00A"
};

export const STATES = {
  ACTIVE: { disableChanges: true, disablePublish: true },
  INACTIVE: { disableChanges: false, disablePublish: false }
};

export const BANNER_TYPES = [
  {
    name: "Incident",
    color: COLORS.INCIDENT,
    text: "We're experiencing technical issues, editing is currently unavailable."
  },
  {
    name: "Maintenance",
    color: COLORS.MAINTENANCE,
    text: "System maintenance in progress, some features might be unavailable"
  }
];

export const LOCKED_STATUS_CODE = 423;
